var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState } from 'react';
import { useTheme } from 'styled-components';
import { useApplicationSize } from '@anwb/providers-application';
import { ANWBDefault } from '@anwb/theme';
import { BlockArrow, BlockContainer, BlockContainerWrapper, BlockContent, BlockIcon, BlockLink, BlockTitle, } from './styles/block.styled';
/**
 * The Block component is used to render a breadcrumb bar with the correct styling
 */
const Block = (_a) => {
    var { ariaLabel, children, href, iconVariant, labelText, variant = 'primary', hasArrow = false } = _a, props = __rest(_a, ["ariaLabel", "children", "href", "iconVariant", "labelText", "variant", "hasArrow"]);
    const theme = useTheme();
    const [contentTypographyVariant, setContentTypographyVariant] = useState('content-subtitle');
    const applicationSize = useApplicationSize();
    useEffect(() => {
        if (applicationSize === 'large') {
            setContentTypographyVariant(theme.name === ANWBDefault.name ? 'content-title' : 'component-title-slim-s');
        }
        else {
            setContentTypographyVariant(theme.name === ANWBDefault.name ? 'content-subtitle' : 'component-title-slim-s-mobile');
        }
    }, [applicationSize, theme.name]);
    return (React.createElement(BlockLink, Object.assign({ href: href, "aria-label": ariaLabel }, props),
        React.createElement(BlockContainer, { tabIndex: 0, "$variant": variant, "data-variant": variant },
            React.createElement(BlockContainerWrapper, null,
                React.createElement(BlockTitle, { variant: theme.name === ANWBDefault.name ? 'body-text' : 'body-text-xs' },
                    React.createElement(BlockIcon, { type: "ui", variant: iconVariant }),
                    labelText),
                React.createElement(BlockContent, { variant: contentTypographyVariant }, children)),
            hasArrow && React.createElement(BlockArrow, { variant: "arrow-right", type: "ui", size: "md", "$variant": variant }))));
};
export default Block;
//# sourceMappingURL=Block.js.map